/**
 * Map T&A role codenames to which scope dimensions (sites / areas) the
 * admin UI should expose for that role. Mirrors the backend matrix in
 * ENG-165.
 */

export const ROLE_CODENAMES_SITE_SCOPED: ReadonlySet<string> = new Set([
  'supervisor',
  'control_room',
  'area_manager',
]);

export const ROLE_CODENAMES_AREA_SCOPED: ReadonlySet<string> = new Set([
  'regional_manager',
]);

export interface TAScopeApplicability {
  sitesApplicable: boolean;
  areasApplicable: boolean;
}

export const scopeApplicabilityForRoleCodename = (
  codename: string | null | undefined,
): TAScopeApplicability => ({
  sitesApplicable: codename ? ROLE_CODENAMES_SITE_SCOPED.has(codename) : false,
  areasApplicable: codename ? ROLE_CODENAMES_AREA_SCOPED.has(codename) : false,
});
